export default __webpack_public_path__ + "static/media/des_2.4ae51fb4.svg";